export const APP_CONST = Object.freeze({
  AUTH_ACTIONS: {
    LOGIN: "login",
    REGISTER: "register",
  },
  TOAST_TYPE: {
    ERROR: "error",
    SUCCESS: "success",
  },
  SPORTS_ID: {
    CIRCKET: "4",
    SOCCER: "1",
    TENNIS: "2",
  },
  ALL_MARKET_IDS: {
    CRICKET: "CRICKET_IDS",
    SOCCER: "SOCCER_IDS",
    TENNIS: "TENNIS_IDS",
  },
  ODDS_TYPE: {
    BACK: "back",
    LAY: "lay",
  },
  PLAYER_BANK_DETAILS_TYPE: {
    Bank: "bank",
    Card: "card",
  },
  TEST: {},
  AUTH_MODAL: {
    LOGIN: "login",
    REGISTER: "register",
    MOBILE_NUMBER: "mobileNumber",
    VERIFY_NUMBER: "verifyNumber",
    FORGOTO_PASSWORD: "forgotpassword",
    RESET_PASSWORD: "resetpassword",
  },
  AUTH_MODAL_ACTION_TYPE: {
    MANUAL: "manual",
    AUTO: "auto",
  },
  ORGANISATION_STATUS: {
    Maintenance: "maintenance",
    Live: "live",
    Suspended: "suspended",
  },
  ENVIRONMENTS: {
    PRODUCTION: "production",
    DEVELOPMENT: "development",
  },
});

export const APP_HOST = "localhost:3000";

export const AFF_QUERY_PARAM = "click_aff_id";
export const AFF_KEY_LS = "track_id";

export const GTW_MODE = {
  Deposit: "deposit",
  Withdraw: "withdraw",
};

export const BankModeRequiredFields = [
  "accountNo",
  "accountName",
  "iban",
  "ifscCode",
  "bankName",
];

export const AppTheme = Object.freeze({
  Dark: "dark",
  Light: "light",
});

export const OTP_TYPE = Object.freeze({
  MOBILE: "mobile",
  EMAIL: "email",
});

export const ThemeStorageKey = "qprtcj";

export const DEFAULT_APP_ROUTES = Object.freeze({
  PUBLIC: "/",
  PROTECTED: "/home",
});

export const DEFAULT_SLIDER_SETTINGS = {
  dots: false,
  arrows: false,
  autoplay: false,
  infinite: true,
  speed: 2000,
  slidesToShow: 7,
  slidesToScroll: 6,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
  ],
};

export const KYC_VERIFICATION_STATUS = Object.freeze({
  Pending: "pending",
  Approved: "approved",
  Declined: "declined",
  Expired: "expired",
});

export const KYC_DOC_TYPES = [
  {
    id: 0,
    name: "Passport",
    key: "passport",
    requiredBackSide: true,
    requiredDocId: true,
  },
  // { id: 1, name: "Emirates Id", key: "emiratesId", requiredBackSide: true },
  {
    id: 2,
    name: "Pancard",
    key: "pancard",
    requiredBackSide: false,
    requiredDocId: true,
  },
  {
    id: 3,
    name: "Adhar Card",
    key: "adharcard",
    requiredBackSide: true,
    requiredDocId: true,
  },
  {
    id: 4,
    name: "Driving License",
    key: "drivinglicense",
    requiredBackSide: false,
    requiredDocId: true,
  },
];

export const MaxFileSize = 4000000; // 4 mb

export const INPUT_TYPE = {
  FILE: "file",
  TEXT: "text",
  DATE: "date",
};

export const SportsLobbyProviders = {
  IgPixel: "ig_pixel",
};

const IgPixelEvents = [
  { name: "Home", serviceName: "Home", slug: "igp-home" },
  { name: "Live", serviceName: "Live", slug: "igp-live" },
  { name: "Prematch", serviceName: "Prematch", slug: "igp-pre-match" },
  { name: "Football", serviceName: "Live", slug: "igp-live-50" },
  {
    name: "Football",
    serviceName: "Prematch",
    slug: "igp-pre-match-50",
  },
  { name: "Basketball", serviceName: "Live", slug: "igp-live-53" },
  {
    name: "Basketball",
    serviceName: "Prematch",
    slug: "igp-pre-match-53",
  },
  { name: "Tennis", serviceName: "Live", slug: "igp-live-52" },
  { name: "Tennis", serviceName: "Prematch", slug: "igp-pre-match-52" },
  { name: "Volleyball", serviceName: "Live", slug: "igp-live-54" },
  {
    name: "Volleyball",
    serviceName: "Prematch",
    slug: "igp-pre-match-54",
  },
  { name: "Ice Hockey", serviceName: "Live", slug: "igp-live-51" },
  {
    name: "Ice Hockey",
    serviceName: "Prematch",
    slug: "igp-pre-match-51",
  },
  { name: "Handball", serviceName: "Live", slug: "igp-live-55" },
  {
    name: "Handball",
    serviceName: "Prematch",
    slug: "igp-pre-match-55",
  },
  { name: "Boxing", serviceName: "Live", slug: "igp-live-57" },
  { name: "Boxing", serviceName: "Prematch", slug: "igp-pre-match-57" },
  { name: "Rugby Union", serviceName: "Live", slug: "igp-live-61" },
  {
    name: "Rugby Union",
    serviceName: "Prematch",
    slug: "igp-pre-match-61",
  },
  { name: "Amer. Football", serviceName: "Live", slug: "igp-live-63" },
  {
    name: "Amer. Football",
    serviceName: "Prematch",
    slug: "igp-pre-match-63",
  },
  { name: "Water Polo", serviceName: "Live", slug: "igp-live-64" },
  {
    name: "Water Polo",
    serviceName: "Prematch",
    slug: "igp-pre-match-64",
  },
  { name: "Futsal", serviceName: "Live", slug: "igp-live-65" },
  { name: "Futsal", serviceName: "Prematch", slug: "igp-pre-match-65" },
  { name: "Darts", serviceName: "Live", slug: "igp-live-69" },
  { name: "Darts", serviceName: "Prematch", slug: "igp-pre-match-69" },
  { name: "Table Tennis", serviceName: "Live", slug: "igp-live-70" },
  {
    name: "Table Tennis",
    serviceName: "Prematch",
    slug: "igp-pre-match-70",
  },
  { name: "Aussie Rules", serviceName: "Live", slug: "igp-live-71" },
  {
    name: "Aussie Rules",
    serviceName: "Prematch",
    slug: "igp-pre-match-71",
  },
  { name: "Formula 1", serviceName: "Live", slug: "igp-live-73" },
  {
    name: "Formula 1",
    serviceName: "Prematch",
    slug: "igp-pre-match-73",
  },
  { name: "Cricket", serviceName: "Live", slug: "igp-live-75" },
  {
    name: "Cricket",
    serviceName: "Prematch",
    slug: "igp-pre-match-75",
  },
  { name: "Floorball", serviceName: "Live", slug: "igp-live-82" },
  {
    name: "Floorball",
    serviceName: "Prematch",
    slug: "igp-pre-match-82",
  },
  { name: "Combat sports", serviceName: "Live", slug: "igp-live-90" },
  {
    name: "Combat sports",
    serviceName: "Prematch",
    slug: "igp-pre-match-90",
  },
  { name: "Rugby League", serviceName: "Live", slug: "igp-live-94" },
  {
    name: "Rugby League",
    serviceName: "Prematch",
    slug: "igp-pre-match-94",
  },
  { name: "E Sports", serviceName: "Live", slug: "igp-live-95" },
  {
    name: "E Sports",
    serviceName: "Prematch",
    slug: "igp-pre-match-95",
  },
  { name: "Squash", serviceName: "Live", slug: "igp-live-96" },
  { name: "Squash", serviceName: "Prematch", slug: "igp-pre-match-96" },
  { name: "Gaelic football", serviceName: "Live", slug: "igp-live-99" },
  {
    name: "Gaelic football",
    serviceName: "Prematch",
    slug: "igp-pre-match-99",
  },
  { name: "Hurling", serviceName: "Live", slug: "igp-live-130" },
  {
    name: "Hurling",
    serviceName: "Prematch",
    slug: "igp-pre-match-130",
  },
];

export const PublicIgPixelUrl = "https://sps4.gsportsbook.com/en/sport";
